import React from "react";
import {Flex} from "@adobe/react-spectrum";
import logo from "../assets/images/af-labs-logo.svg";
import styled from "@emotion/styled";
import {useMediaQuery} from "react-responsive";
import {PHONE_MAX_WIDTH, TABLET_MAX_WIDTH} from "../utils/constants";

const AppHeaderStyled = styled.div({
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#2C2A26"
})

function AppHeader() {

    const isTablet = useMediaQuery({minWidth: PHONE_MAX_WIDTH + 1, maxWidth: TABLET_MAX_WIDTH});
    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    return (
        <AppHeaderStyled>
            <Flex
                alignItems="center"
                gap="size-200"
                marginX={20}
                width="100%"
                height={(isPhone || isTablet) ? "66px" : "94px"}>
                <object type="image/svg+xml" data={logo} height="32">Adobe Fonts Labs</object>
            </Flex>
        </AppHeaderStyled>
    );
}

export default AppHeader;